"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentConfigurationModel = void 0;
const BaseModel_1 = require("./base/BaseModel");
class PaymentConfigurationModel extends BaseModel_1.BaseModel {
    constructor(options) {
        super(options);
    }
    async delete() {
        await this.options.clients.provisionChargingStationClient().removePaymentConfiguration({
            org_id: this.org.id,
            id: this.options.model.id
        });
        super.delete();
    }
    get model() {
        return this.options.model;
    }
    get org() {
        return this.options.org;
    }
}
exports.PaymentConfigurationModel = PaymentConfigurationModel;
